<template>
    <div class="member-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='common-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="common-footer">
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><i class='iconfont icon-homepage' /><span class='text'>首页</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeGoodsclass'}" id='home_goodsclass'><router-link :to="{ name: 'HomeGoodsclass'}" class='item'><i class="iconfont icon-fenlei" /><span class='text'>分类</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeSearch'}" id='home_search'><router-link :to="{ name: 'HomeSearch'}" class='item'><i class="iconfont icon-sousuo1" /><span class='text'>搜索</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeCart'}" id='home_cart'><router-link :to="{ name: 'HomeCart'}" class='item'><i class='iconfont icon-31gouwuche' /><span class='text'>购物车</span><span class="icon" v-if="cartNumber > 0">{{ getCarCount }}</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberIndex'}" id='member_index'><router-link :to="{ name: 'MemberIndex'}" class='item'><i class='iconfont icon-people' /><span class='text'>我的</span></router-link></mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { cartQuantity } from '../../api/homecart'
export default {
  name: 'MemberBase',
  data () {
    return {
      home_selected: 'member_index',
        cartNumber: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info,
        isOnline: state => state.member.isOnline
    }),
      getCarCount () {
          if (this.cartNumber > 0 && this.cartNumber < 100) {
              return this.cartNumber
          } else if (this.cartNumber >= 100) {
              return '99+'
          }
      }
  },
  created: function () {
    if (!this.user) {
      this.$router.push({ name: 'HomeMemberLogin' , query: { clear: 1 }})
    }
      this.getCartCount()
  },
    methods: {
        getCartCount () {
            if (this.isOnline) {
                cartQuantity().then(res => {
                    if (res) {
                        this.cartNumber = res.result.cart_count
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .item-wrap{position: relative}
    .icon {
        position: absolute;
        right: 0.8rem;
        top: 0.2rem;
        font-size: 0.5rem;
        line-height: 0.7rem;
        width: 0.9rem;
        height: 0.7rem;
        background: #ef3338;
        border-radius: 1rem;
        text-align: center;
        color: #ffffff;
    }
</style>
